import { TableCellInfo } from 'js/components'

export const NodeHeaders: TableCellInfo[] = [
  {
    align: 'inherit',
    content: 'Moniker',
  },
  {
    align: 'inherit',
    content: 'Location',
  },
  {
    align: 'inherit',
    content: 'Endpoint',
  },
  {
    align: 'inherit',
    content: 'Node ID',
  },
  {
    align: 'inherit',
    content: 'App Version',
  },
  {
    align: 'inherit',
    content: 'App Commit',
  },
  {
    align: 'inherit',
    content: 'Height',
  },
]
